import { render, staticRenderFns } from "./SellerIdentityCard.vue?vue&type=template&id=3d019a4a&scoped=true"
import script from "./SellerIdentityCard.vue?vue&type=script&lang=js"
export * from "./SellerIdentityCard.vue?vue&type=script&lang=js"
import style0 from "./SellerIdentityCard.vue?vue&type=style&index=0&id=3d019a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d019a4a",
  null
  
)

export default component.exports